import React from 'react';
import { Button, Switch, Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';

/** stages that can be run by hand; the rest fire on their own */
const TRIGGERABLE = ['optimiser', 'change_instance_validator'];

export const prettyActionType = (value?: string) => (
    value ? value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '—'
);

/**
 * One processor under the shared column header. The row opens it; the switch
 * and the trigger act on it in place, so both stop the click from reaching the
 * row underneath them.
 */
const AIProcessorRow = ({
    record,
    detailPath,
    isAdmin,
    onToggleActive,
    onTrigger,
}: {
    record: any;
    detailPath: string;
    isAdmin: boolean;
    onToggleActive: (record: any, active: boolean) => void;
    onTrigger: (record: any) => void;
}) => {
    const history = useHistory();
    const open = () => history.push(`${detailPath}/${record.id}`);

    return (
        <div
            className="ap-row"
            role="button"
            tabIndex={0}
            aria-label={`Open ${record.name}`}
            onClick={open}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    open();
                }
            }}
        >
            <Tooltip placement="topLeft" title={record.name}>
                <div className="ap-name">{record.name}</div>
            </Tooltip>

            <Tooltip placement="topLeft" title={record.llm_model?.name}>
                <div className="ap-cell" data-label="LLM model">{record.llm_model?.name || '—'}</div>
            </Tooltip>

            <Tooltip placement="topLeft" title={record.service?.name}>
                <div className="ap-cell" data-label="Service">{record.service?.name || '—'}</div>
            </Tooltip>

            <div className="ap-cell ap-cell--stage" data-label="Stage">{prettyActionType(record.action_type)}</div>

            {/* these act on the processor in place, so the click stops here
                rather than opening the row underneath */}
            <div
                className="ap-actions"
                role="presentation"
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
            >
                {isAdmin && TRIGGERABLE.includes(record.action_type) && (
                    <Button size="small" disabled={!record.active} onClick={() => onTrigger(record)}>
                        Trigger
                    </Button>
                )}
                {isAdmin && (
                    <Switch
                        className="ap-active"
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        defaultChecked={record.active}
                        onChange={(checked) => onToggleActive(record, checked)}
                    />
                )}
            </div>
        </div>
    );
};

export default AIProcessorRow;
